<template>
  <div class="common">
    <div style="text-align: center;">
      <div class="item-box">即将支付</div>
      <div class="item-box">
        <label class="text-color-orange">{{ totalAmt | splitK }} 元</label>
      </div>
      <div class="item-box">
        <label>接收方：</label>{{ modalData.recPersonInfo.cstNm }}
      </div>
      <a-input type="password" v-model="txnPwd" class="item-input" placeholder="交易密码" />
    </div>
    <a-divider />
    <a-form-model class="common-form-inline" ref="ruleForm" :model="goldpageData" :label-col="{ span: 3 }"
      :wrapper-col="{ span: 13 }">
      <a-form-model-item label="附件上传" prop="fileId">
        <div style="position:relative">
          <fileUpload accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip" ref="fileUpload"
            :paramObj="uploadParam" @uploadOkCopy='uploadOkCopy' @handleFileRemove="removeOk" :removeaction="true"
            :limit="50" :fileListShow='false' name="file" />
          <div class="text-color-orange img-tip">温馨提示：1、每次上传最多不超过50个文件
            2、支持PNG、JPG、JPEG、PDF、单个文件不能超过100M</div>
        </div>
      </a-form-model-item>
    </a-form-model>

    <a-table :pagination="false" :columns="columns" :data-source="tableData" bordered :locale="{ emptyText: '暂无数据' }">
      <template slot="fileName" slot-scope="text, record">
        <a>{{ text }}</a>
      </template>
      <template slot="status" slot-scope="text, record">
        <div>{{ text }}</div>
      </template>
      <template slot="action" slot-scope="text, record">
        <div>
          <a-button type="link" @click="handleSort(record, 'up')">上移</a-button>
          <a-button type="link" @click="handleSort(record, 'down')">下移</a-button>
          <a-button type="link" @click="handleDel(record)">删除</a-button>
        </div>
      </template>
    </a-table>
    <div class="spaceCenter model-footer-btns">
      <a-button class="btn-blue-line btn-big" @click="modalCancel">取消</a-button>
      <a-button class="btn-big" type="primary" @click="modalOk" :loading="modalLoad" :disabled="!txnPwd">确定</a-button>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword, payApi } from '@/api/gold.js';
import { updateVoucherSort, updateFileSort } from '@/api/payable.js';
import { fileSaveAPI } from '@/api/file.js';

export default {
  props: ['modalData'],
  name: 'goldPayModal',
  data() {
    return {
      modalLoad: false,
      txnPwd: '',
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable'
      },
      goldpageData: {
        file: null,
        fileId: undefined
      },
      fileId: undefined,
      columns: [
        {
          title: '文件名称',
          dataIndex: 'fileName',
          ellipsis: true,
          key: 'fileName',
          scopedSlots: { customRender: 'fileName' }
        },
        {
          title: '上传结果',
          dataIndex: 'status',
          ellipsis: true,
          key: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          ellipsis: true,
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: []
    };
  },
  computed: {
    totalAmt() {
      let list = this.modalData.list || [];
      let sum = 0;
      list.forEach((i) => (sum += Number(i.payAmt)));
      return sum;
    }
  },
  created() { },
  mounted() { },
  methods: {
    //排序
    updateSort(data) {
      updateVoucherSort({ list: data }).then((res) => {
        //获取列表接口
      });
    },
    handleSort(data, text) {
      console.log('%c Line:114 🍓 data', 'color:#4fff4B', data);
      let sort = null;
      let sort1 = null;
      let uid = null;
      if (text == 'up') {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) + 1;
        if (sort > this.tableData.length) {
          return;
        }
        sort1 = data.sort;
        uid = this.tableData[data.index - 1].uid;
      } else {
        if (this.tableData.length < 2) {
          return;
        }
        sort = Number(data.sort) - 1;
        if (sort < 1) {
          return;
        }
        sort1 = data.sort;
        uid = this.tableData[data.index + 1].uid;
      }
      let params = [
        { uid: data.uid, sort: sort },
        { uid: uid, sort: sort1 }
      ];
      console.log(params);
      params.forEach((it) => {
        this.tableData.forEach((it1) => {
          if (it1.uid == it.uid) {
            it1.sort = it.sort;
          }
        });
      });
      this.tableData = this.tableData
        .sort((a, b) => Number(b.sort) - Number(a.sort))
        .map((it, index) => {
          return { ...it, index: index };
        });
    },
    // 删除文件
    removeOk() {
      this.goldpageData.file = null;
      this.goldpageData.fileId = undefined;
    },
    async fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: 'payable'
      };
      await fileSaveAPI(param)
        .then((res) => {
          this.uploading = false;
          this.goldpageData.fileId = res.data.fileId;
          this.goldpageData.file = data;
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('fileId');
          this.tableData.forEach((it) => {
            if (it.fileRte == data.fileRte) {
              it.fileId = res.data.fileId;
              it.id = res.data.id;
            }
          });

          this.tableData = this.tableData
            .sort((a, b) => Number(b.sort) - Number(a.sort))
            .map((it, index) => {
              return { ...it, index: index };
            });
        })
        .catch((err) => {
          this.uploading = false;
          console.log(err);
        });
    },
    uploadOkCopy(fileObj) {
      const lastElement = fileObj;
      this.tableData.unshift({ ...lastElement, fileName: lastElement.name, status: '上传成功', sort: this.tableData.length + 1, index: this.tableData.length });
      // this.tableData = resList
      //   .map((item, index) => {
      //     return {
      //       ...item,
      //       fileName: item.name,
      //       sort:index+1,
      //       index,
      //       status: '上传成功'
      //     };
      //   })
      //   .sort((a, b) => Number(b.sort) - Number(a.sort));
      console.log('%c Line:189 🍡 this.tableData', 'color:#fca650', this.tableData);

      this.fileSave(lastElement);
    },
    handleDel(row) {
      console.log('%c Line:203 🥤 row', 'color:#ffdd4d', row);
      this.$refs.fileUpload.handleFileRemove(row);
      this.tableData = this.tableData.filter((i) => i.uid != row.uid);
    },
    modalOk(e) {
      this.modalLoad = true;
      if (this.modalData.selectedIsFund == 0) {
        if (!this.goldpageData.file && !this.goldpageData.fileId) {
          this.modalLoad = false;
          this.$message.warn('请上传附件');
          return;
        }
      }
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params)
        .then((res) => {
          console.log("%c Line:229 🍐 this.tableData", "color:#465975", this.tableData);

          let p = {
            gldListStr: JSON.stringify(this.modalData.list),
            txnPwd: this.utils.getPasswordEncryptString(this.txnPwd),
            recPersonInfo: JSON.stringify(this.modalData.recPersonInfo),
            idList: this.tableData.map((i) => i.id).join(',')
          };
          this.$nextTick(() => {
            this.pay(p);
            this.updateFileSort();
            console.log('%c Line:215 🍭 p', 'color:#fca650', p);
          });

        })
        .catch((error) => {
          this.modalLoad = false;
          this.$emit('error', error);
        });
    },
    updateFileSort() {
      console.log('%c Line:237 🥃 arr', 'color:#fca650', 'arr');

      let arr = this.tableData.map((i) => {
        return { id: i.id, sort: i.sort };
      });
      console.log('%c Line:237 🥃 arr', 'color:#fca650', arr);

      updateFileSort({ list: JSON.stringify(arr) });
    },
    pay(params) {
      payApi(params)
        .then((res) => {
          this.modalLoad = false;
          this.$emit('ok', res.data);
        })
        .catch((error) => {
          this.modalLoad = false;
          this.$emit('error', error);
        });
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit('cancel');
    },
    save(btn) {
      let inItem = this.tableData.find((i) => i.voucherCode == this.goldpageData.voucherCode);
      if (inItem) {
        this.$message.warn('凭证信息已在列表中，不可重复提交');
        btn && btn.closeLoad();
        return;
      }
      let current_index_max = this.tableData.length;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let listStr = [];
          this.invDataList.forEach((item, index) => {
            listStr.push({
              ...this.goldpageData,
              sellerOrgCode: item.sellrOrgCode,
              buyerOrgCode: item.buryOrgCode,
              cyCode: item.cyCode,
              name: this.goldpageData.file.name,
              //计算排序值
              sort: current_index_max + 1
            });
          });
          addBatchVoucher({ listStr: JSON.stringify(listStr) })
            .then((res) => {
              this.$message.success('操作成功');
              btn && btn.closeLoad();
              this.initData();
              this.getInfo();
              this.$emit('save');
            })
            .catch((err) => {
              btn && btn.closeLoad();
              console.log(err);
            });
        } else {
          btn && btn.closeLoad();
        }
      });
    }
  }
};
</script>
<style scoped>
.item-box>label {
  min-width: 70px;
}

.item-box {
  margin: 0 15px 15px 0;
}

.item-input {
  width: 200px;
}

.model-footer-btns {
  margin-top: 16px;
}

.text-color-orange {
  color: #ef763c;
}

.img-tip {
  white-space: nowrap;
  position: absolute;
  left: 120px;
  font-size: 12px;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-pay-modal.vue